import { render, staticRenderFns } from "./CalificacionesClienteOculto.vue?vue&type=template&id=3b46fff4&scoped=true&"
import script from "./CalificacionesClienteOculto.vue?vue&type=script&lang=js&"
export * from "./CalificacionesClienteOculto.vue?vue&type=script&lang=js&"
import style0 from "./CalificacionesClienteOculto.vue?vue&type=style&index=0&id=3b46fff4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b46fff4",
  null
  
)

export default component.exports